var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show && _vm.performedPreFillCheck
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", [
          _c("div", { staticClass: "jon" }, [_c("Jon")], 1),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          {
            ref: "main",
            class: _vm.mainClass,
            attrs: { id: "job-questionnaire-main" }
          },
          [
            _vm.allDone
              ? _c(
                  "div",
                  { staticClass: "all-done" },
                  [
                    _c("Avatar", { attrs: { avatar: _vm.avatarRocket } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "all-done-text" }, [
                      _vm._v(
                        "\n\t\t\t\tYeah, super, du hast alles erledigt!\n\t\t\t"
                      )
                    ])
                  ],
                  1
                )
              : _vm.breakType
              ? _c("BreakDisplay", { attrs: { type: _vm.breakType } })
              : _vm._l(_vm.inquiriesToEdit, function(inquiry, i) {
                  return _c(
                    "div",
                    {
                      key: inquiry.id,
                      class: [
                        "item-container",
                        inquiry.id,
                        { "d-none": i !== _vm.inquiryIndexToEdit }
                      ]
                    },
                    [
                      _vm.forcedMessages
                        ? _c(
                            "div",
                            { staticClass: "messages" },
                            _vm._l(_vm.forcedMessages, function(message, j) {
                              return _c(
                                "div",
                                {
                                  key: "forced-message--" + j + "--" + j,
                                  staticClass: "message",
                                  style: { "animation-delay": j + "s" }
                                },
                                [
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(message) }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            { staticClass: "messages" },
                            _vm._l(_vm.getMessages(inquiry.id), function(
                              message,
                              j
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "message--" + inquiry.id + "--" + j,
                                  staticClass: "message",
                                  style: { "animation-delay": j + "s" }
                                },
                                [
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(message) }
                                  })
                                ]
                              )
                            }),
                            0
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: ["item-edit", { skip: _vm.skip }],
                          style: {
                            "animation-delay":
                              _vm.getMessages(inquiry.id).length + "s"
                          }
                        },
                        [
                          _vm.isItemToEdit("function", i)
                            ? _c("Function", {
                                class: { "d-none": inquiry.id !== "function" },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("function")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("function", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("employment-mode", i)
                            ? _c("EmploymentMode", {
                                class: {
                                  "d-none": inquiry.id !== "employment-mode"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("employment-mode")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "employment-mode",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("working-time", i)
                            ? _c("WorkingTime", {
                                class: {
                                  "d-none": inquiry.id !== "working-time"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("working-time")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "working-time",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("career-level", i)
                            ? _c("CareerLevel", {
                                class: {
                                  "d-none": inquiry.id !== "career-level"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("career-level")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "career-level",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("industrial-sector", i)
                            ? _c("IndustrialSector", {
                                class: {
                                  "d-none": inquiry.id !== "industrial-sector"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("industrial-sector")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "industrial-sector",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("organisational-area", i)
                            ? _c("OrganisationalArea", {
                                class: {
                                  "d-none": inquiry.id !== "organisational-area"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("organisational-area")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "organisational-area",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("place-of-work", i)
                            ? _c("PlaceOfWork", {
                                class: {
                                  "d-none": inquiry.id !== "place-of-work"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("place-of-work")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "place-of-work",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("company-type", i)
                            ? _c("CompanyType", {
                                class: {
                                  "d-none": inquiry.id !== "company-type"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("company-type")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "company-type",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("company-size", i)
                            ? _c("CompanySize", {
                                class: {
                                  "d-none": inquiry.id !== "company-size"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("company-size")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "company-size",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("function-detail", i)
                            ? _c("FunctionDetail", {
                                class: {
                                  "d-none": inquiry.id !== "function-detail"
                                },
                                attrs: {
                                  value: _vm.getItemData("function-detail")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "function-detail",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("function-legal-field", i)
                            ? _c("FunctionLegalField", {
                                class: {
                                  "d-none":
                                    inquiry.id !== "function-legal-field"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("function-legal-field")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "function-legal-field",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("function-tax-field", i)
                            ? _c("FunctionTaxField", {
                                class: {
                                  "d-none": inquiry.id !== "function-tax-field"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("function-tax-field")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "function-tax-field",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("salary", i)
                            ? _c("Salary", {
                                class: { "d-none": inquiry.id !== "salary" },
                                attrs: { value: _vm.getItemData("salary") },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("salary", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("hourly-rate", i)
                            ? _c("HourlyRate", {
                                class: {
                                  "d-none": inquiry.id !== "hourly-rate"
                                },
                                attrs: {
                                  value: _vm.getItemData("hourly-rate")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "hourly-rate",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("working-hours", i)
                            ? _c("WorkingHours", {
                                class: {
                                  "d-none": inquiry.id !== "working-hours"
                                },
                                attrs: {
                                  value: _vm.getItemData("working-hours")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "working-hours",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("employment-duration", i)
                            ? _c("EmploymentDuration", {
                                class: {
                                  "d-none": inquiry.id !== "employment-duration"
                                },
                                attrs: {
                                  value: _vm.getItemData("employment-duration")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "employment-duration",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("legitimation", i)
                            ? _c("Legitimation", {
                                class: {
                                  "d-none": inquiry.id !== "legitimation"
                                },
                                attrs: {
                                  value: _vm.getItemData("legitimation"),
                                  "job-profile": _vm.jobProfile.jobProfile
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "legitimation",
                                      $event
                                    )
                                  },
                                  confirmMobilePhone: function($event) {
                                    return _vm.setForcedMessages(
                                      [
                                        "SMS für dich!",
                                        "Bitte bestätige deine Mobilnummer."
                                      ],
                                      true
                                    )
                                  },
                                  checkData: function($event) {
                                    return _vm.setForcedMessages(
                                      [
                                        "Bitte überprüfe deine Angaben",
                                        "Vorname und Nachname können später nicht mehr geändert werden."
                                      ],
                                      false
                                    )
                                  },
                                  changeData: function($event) {
                                    return _vm.setForcedMessages(
                                      undefined,
                                      false
                                    )
                                  },
                                  scrollIntoView: _vm.scrollBottom,
                                  finish: _vm.onFinishLegitimation
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("function-experience", i)
                            ? _c("DesireAdditions", {
                                class: {
                                  "d-none": inquiry.id !== "function-experience"
                                },
                                attrs: {
                                  "characteristic-type": _vm.meta.functionType,
                                  "characteristic-items": _vm.meta.function,
                                  desire: _vm.getInitialDesires(
                                    "function",
                                    _vm.meta.function
                                  ),
                                  value: _vm.getItemData("function-experience"),
                                  "addition-config": {
                                    inline: true,
                                    experience: {
                                      enabled: true,
                                      noneAllowed: true
                                    },
                                    selfAssessment: {
                                      enabled: false
                                    },
                                    education: {
                                      enabled: false
                                    }
                                  },
                                  "supplements-config": {
                                    nothingAllowed: true,
                                    types: _vm.functionExperienceSupplementTypes
                                  },
                                  "further-messages": [
                                    "Werden weitere Berufserfahrungen benötigt?"
                                  ],
                                  "label-type": _vm.labelTypeJobProfile,
                                  type: "job-profile"
                                },
                                on: {
                                  furtherAppeared: function($event) {
                                    return _vm.addDisableSkip(
                                      "function-experience"
                                    )
                                  },
                                  additionsEdit: _vm.onDesireAdditionsEdit,
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "function-experience",
                                      $event
                                    )
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "deleteConfirmText",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tMöchtest du die Tätigkeits-Erfahrung\n\t\t\t\t\t\t\t"
                                          ),
                                          _c("Label", {
                                            staticClass:
                                              "font-weight-extra-bold",
                                            attrs: {
                                              characteristic: data.item.item
                                            }
                                          }),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("function-legal-field-experience", i)
                            ? _c("DesireAdditions", {
                                class: {
                                  "d-none":
                                    inquiry.id !==
                                    "function-legal-field-experience"
                                },
                                attrs: {
                                  "characteristic-type":
                                    _vm.meta.functionLegalFieldType,
                                  "characteristic-items":
                                    _vm.meta.functionLegalField,
                                  desire: _vm.getInitialDesires(
                                    "function-legal-field",
                                    _vm.meta.functionLegalField
                                  ),
                                  value: _vm.getItemData(
                                    "function-legal-field-experience"
                                  ),
                                  "addition-config": {
                                    inline: true,
                                    experience: {
                                      enabled: true,
                                      noneAllowed: true
                                    },
                                    selfAssessment: {
                                      enabled: false
                                    },
                                    education: {
                                      enabled: false
                                    }
                                  },
                                  "further-messages": [
                                    "Werden weitere Rechtsgebiets-Erfahrungen benötigt?"
                                  ],
                                  "label-type": _vm.labelTypeJobProfile,
                                  type: "job-profile"
                                },
                                on: {
                                  furtherAppeared: function($event) {
                                    return _vm.addDisableSkip(
                                      "function-legal-field-experience"
                                    )
                                  },
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "function-legal-field-experience",
                                      $event
                                    )
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "deleteConfirmText",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tMöchtest du die Rechtsgebiets-Erfahrung\n\t\t\t\t\t\t\t"
                                          ),
                                          _c("Label", {
                                            staticClass:
                                              "font-weight-extra-bold",
                                            attrs: {
                                              characteristic: data.item.item
                                            }
                                          }),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("function-tax-field-experience", i)
                            ? _c("DesireAdditions", {
                                class: {
                                  "d-none":
                                    inquiry.id !==
                                    "function-tax-field-experience"
                                },
                                attrs: {
                                  "characteristic-type":
                                    _vm.meta.functionTaxFieldType,
                                  "characteristic-items":
                                    _vm.meta.functionTaxField,
                                  desire: _vm.getInitialDesires(
                                    "function-tax-field",
                                    _vm.meta.functionTaxField
                                  ),
                                  value: _vm.getItemData(
                                    "function-tax-field-experience"
                                  ),
                                  "addition-config": {
                                    inline: true,
                                    experience: {
                                      enabled: true,
                                      noneAllowed: true
                                    },
                                    selfAssessment: {
                                      enabled: false
                                    },
                                    education: {
                                      enabled: false
                                    }
                                  },
                                  "further-messages": [
                                    "Werden weitere Steuergebiets-Erfahrungen benötigt?"
                                  ],
                                  "label-type": _vm.labelTypeJobProfile,
                                  type: "job-profile"
                                },
                                on: {
                                  furtherAppeared: function($event) {
                                    return _vm.addDisableSkip(
                                      "function-tax-field-experience"
                                    )
                                  },
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "function-tax-field-experience",
                                      $event
                                    )
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "deleteConfirmText",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tMöchtest du die Steuergebiets-Erfahrung\n\t\t\t\t\t\t\t"
                                          ),
                                          _c("Label", {
                                            staticClass:
                                              "font-weight-extra-bold",
                                            attrs: {
                                              characteristic: data.item.item
                                            }
                                          }),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("industrial-sector-experience", i)
                            ? _c("DesireAdditions", {
                                class: {
                                  "d-none":
                                    inquiry.id !==
                                    "industrial-sector-experience"
                                },
                                attrs: {
                                  "characteristic-type":
                                    _vm.meta.industrialSectorType,
                                  "characteristic-items":
                                    _vm.meta.industrialSector,
                                  desire: _vm.getInitialDesires(
                                    "industrial-sector",
                                    _vm.meta.industrialSector
                                  ),
                                  value: _vm.getItemData(
                                    "industrial-sector-experience"
                                  ),
                                  "addition-config": {
                                    inline: true,
                                    experience: {
                                      enabled: true,
                                      noneAllowed: true
                                    },
                                    selfAssessment: {
                                      enabled: false
                                    },
                                    education: {
                                      enabled: false
                                    }
                                  },
                                  "further-messages": [
                                    "Ist weitere Erfahrung in bestimmten Branchen erforderlich?"
                                  ],
                                  "label-type": _vm.labelTypeJobProfile,
                                  type: "job-profile"
                                },
                                on: {
                                  furtherAppeared: function($event) {
                                    return _vm.addDisableSkip(
                                      "industrial-sector-experience"
                                    )
                                  },
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "industrial-sector-experience",
                                      $event
                                    )
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "deleteConfirmText",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tMöchtest du die Branchen-Erfahrung\n\t\t\t\t\t\t\t"
                                          ),
                                          _c("Label", {
                                            staticClass:
                                              "font-weight-extra-bold",
                                            attrs: {
                                              characteristic: data.item.item
                                            }
                                          }),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("career-level-experience", i)
                            ? _c("DesireAdditions", {
                                class: {
                                  "d-none":
                                    inquiry.id !== "career-level-experience"
                                },
                                attrs: {
                                  "characteristic-type":
                                    _vm.meta.careerLevelType,
                                  "characteristic-items": _vm.meta.careerLevel,
                                  desire: _vm.getInitialDesires(
                                    "career-level",
                                    _vm.meta.careerLevel
                                  ),
                                  value: _vm.getItemData(
                                    "career-level-experience"
                                  ),
                                  "addition-config": {
                                    inline: true,
                                    experience: {
                                      enabled: true,
                                      noneAllowed: true
                                    },
                                    selfAssessment: {
                                      enabled: false
                                    },
                                    education: {
                                      enabled: false
                                    }
                                  },
                                  "further-messages": [
                                    "Werden weitere Berufsebenen-Erfahrungen benötigt?"
                                  ],
                                  "label-type": _vm.labelTypeJobProfile,
                                  type: "job-profile"
                                },
                                on: {
                                  furtherAppeared: function($event) {
                                    return _vm.addDisableSkip(
                                      "career-level-experience"
                                    )
                                  },
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "career-level-experience",
                                      $event
                                    )
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "deleteConfirmText",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tMöchtest du die Berufsebenen-Erfahrung\n\t\t\t\t\t\t\t"
                                          ),
                                          _c("Label", {
                                            staticClass:
                                              "font-weight-extra-bold",
                                            attrs: {
                                              characteristic: data.item.item
                                            }
                                          }),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("skills", i)
                            ? _c("Skills", {
                                class: { "d-none": inquiry.id !== "skills" },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("skills")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("skills", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("hiring-date", i)
                            ? _c("HiringDate", {
                                class: {
                                  "d-none": inquiry.id !== "hiring-date"
                                },
                                attrs: {
                                  value: _vm.getItemData("hiring-date")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "hiring-date",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("language", i)
                            ? _c("Language", {
                                class: { "d-none": inquiry.id !== "language" },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("language")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("language", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("software-main", i)
                            ? _c("SoftwareMain", {
                                class: {
                                  "d-none": inquiry.id !== "software-main"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("software-main")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "software-main",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("software-special", i)
                            ? _c("SoftwareSpecial", {
                                class: {
                                  "d-none": inquiry.id !== "software-special"
                                },
                                attrs: {
                                  value: _vm.getItemData("software-special")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "software-special",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("parking", i)
                            ? _c("Parking", {
                                class: { "d-none": inquiry.id !== "parking" },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("parking")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("parking", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("benefits", i)
                            ? _c("Benefits", {
                                class: { "d-none": inquiry.id !== "benefits" },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("benefits")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("benefits", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("public-transport", i)
                            ? _c("PublicTransport", {
                                class: {
                                  "d-none": inquiry.id !== "public-transport"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("public-transport")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "public-transport",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("company-car", i)
                            ? _c("CompanyCar", {
                                class: {
                                  "d-none": inquiry.id !== "company-car"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("company-car")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "company-car",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("private-vehicle-company-usage", i)
                            ? _c("PrivateVehicleCompanyUsage", {
                                class: {
                                  "d-none":
                                    inquiry.id !==
                                    "private-vehicle-company-usage"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData(
                                    "private-vehicle-company-usage"
                                  )
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "private-vehicle-company-usage",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("customer-contact", i)
                            ? _c("CustomerContact", {
                                class: {
                                  "d-none": inquiry.id !== "customer-contact"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("customer-contact")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "customer-contact",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("management", i)
                            ? _c("Management", {
                                class: {
                                  "d-none": inquiry.id !== "management"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("management")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("management", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("overtime", i)
                            ? _c("Overtime", {
                                class: { "d-none": inquiry.id !== "overtime" },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("overtime")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("overtime", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("travel-willingness", i)
                            ? _c("TravelWillingness", {
                                class: {
                                  "d-none": inquiry.id !== "travel-willingness"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("travel-willingness")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "travel-willingness",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("driving-license", i)
                            ? _c("DrivingLicense", {
                                class: {
                                  "d-none": inquiry.id !== "driving-license"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("driving-license")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "driving-license",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("pilot-license", i)
                            ? _c("PilotLicense", {
                                class: {
                                  "d-none": inquiry.id !== "pilot-license"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("pilot-license")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "pilot-license",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("education", i)
                            ? _c("Education", {
                                class: { "d-none": inquiry.id !== "education" },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("education")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData("education", $event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("citizenship", i)
                            ? _c("Citizenship", {
                                class: {
                                  "d-none": inquiry.id !== "citizenship"
                                },
                                attrs: {
                                  meta: _vm.meta,
                                  value: _vm.getItemData("citizenship")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "citizenship",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemToEdit("home-office-advanced", i)
                            ? _c("HomeOffice", {
                                class: {
                                  "d-none":
                                    inquiry.id !== "home-office-advanced"
                                },
                                attrs: {
                                  "emit-change-on-mount": true,
                                  meta: _vm.meta,
                                  value: _vm.getItemData("home-office-advanced")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setItemData(
                                      "home-office-advanced",
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                })
          ],
          2
        ),
        _vm._v(" "),
        !_vm.isLegitimation || _vm.breakType
          ? _c("footer", { staticClass: "align-items-baseline" }, [
              _c("div", { staticClass: "footer--button-container" }, [
                _c(
                  "div",
                  { staticClass: "flex-grow-1" },
                  [
                    _vm.inquiryIndexToEdit > 0 &&
                    !_vm.finishingItem &&
                    !_vm.allDone &&
                    !_vm.hideGoBack
                      ? _c("Button", {
                          attrs: {
                            text: "Zurück",
                            secondary: "",
                            disabled: !_vm.canGoBack || _vm.finishingItem
                          },
                          on: { click: _vm.goBack }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end"
                    },
                    [
                      _vm.canSkip
                        ? _c(
                            "b-form-checkbox",
                            {
                              staticClass:
                                "d-none d-md-block mr-2 mt-2 mt-md-0",
                              attrs: { value: true },
                              model: {
                                value: _vm.skip,
                                callback: function($$v) {
                                  _vm.skip = $$v
                                },
                                expression: "skip"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\tIch möchte diese Frage später beantworten.\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allDone
                        ? _c("Button", {
                            attrs: { text: "Schließen", icon: "checkmark" },
                            on: { click: _vm.close }
                          })
                        : _c("Button", {
                            attrs: {
                              text: "Weiter",
                              icon: "checkmark",
                              disabled: !_vm.canContinue || _vm.finishingItem,
                              loading: _vm.finishingItem
                            },
                            on: { click: _vm.finishItem }
                          })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isShowItemEditableInfo
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-md-block font-size-smaller mt-3"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\tDeine Angaben können nachträglich noch geändert werden.\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-md-none mt-2" },
                [
                  _vm.canSkip
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mr-2",
                          attrs: { value: true },
                          model: {
                            value: _vm.skip,
                            callback: function($$v) {
                              _vm.skip = $$v
                            },
                            expression: "skip"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\tIch möchte diese Frage später beantworten.\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowItemEditableInfo
                    ? _c("div", { staticClass: "font-size-smaller mt-3" }, [
                        _vm._v(
                          "\n\t\t\t\tAlle deine Angaben können nachträglich noch geändert werden.\n\t\t\t"
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }